
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M37.39 2.34A26.5 26.5 0 000 26.5 26.5 26.5 0 1037.39 2.34zM26.5 51A24.48 24.48 0 1151 26.5 24.48 24.48 0 0126.5 51z","fill":"currentColor"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M29.21 16.71A3.24 3.24 0 1126 13.47a3.23 3.23 0 013.21 3.24zM29.39 23.51h-7.31v4.43h1.7v7.33h-1.7v4.26h8.84v-4.26h-1.53V23.51z"}})])
          )
        }
      }
    